import { MODALS } from '~/shared/constants/modals';
import { openResponsiveModal } from '~/shared/ui/ResponsiveModals';

export const openTraderEditor = (id: string) =>
    openResponsiveModal({
        modal: MODALS.PAYIN_TRADER_EDITOR,
        modalId: MODALS.PAYIN_TRADER_EDITOR,
        modalProps: { size: 'lg' },
        innerProps: {
            id,
        },
        title: 'Управление трейдером',
    });
